"use client";

import React from "react";

import { Banner } from "@/components/Banner";
import { Typography } from "@/components/Typography";
import { AboutScanToolModuleProps } from "./types";

import "./styles.scss";

export const AboutScanToolModule = ({ data }: AboutScanToolModuleProps) => {
  const { title, subtitle, content, content_2 } = data;
  return (
    <Banner
      big
      light
      customBgColor="neutral-white"
    >
      <div className="about-scan-tool-module">
        <div className="about-scan-tool-module__header">
          <Typography Tag="span">{title}</Typography>
          <Typography Tag="h2">{subtitle}</Typography>
        </div>
        <div className="about-scan-tool-module__content">
          <Typography Tag="p">{content}</Typography>
          <Typography Tag="p">{content_2}</Typography>
        </div>
      </div>
    </Banner>
  );
};
